<template>
  <div
    :ref="`mappin${index}`"
    class="map-pin"
    @click="viewPole(pole)"
    :style="`z-index: ${total + index}`"
    @mouseover="movePin(index, true)"
    @mouseleave="movePin(index, false)"
  >
    <span class="badge badge-pill rounded-circle" :class="poleColor">
      {{ poleLabel }}
    </span>
    <p>{{ poleNumber }}</p>
    <font-awesome-icon
      v-if="maintenanceStatus"
      :icon="['fas', 'wrench']"
      class="ml-2"
      :class="maintenanceColor"
    />
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl/dist/mapbox-gl.js";

export default {
  props: ["pole", "map", "index", "total"],
  computed: {
    poleNumber() {
      if (this.pole) {
        return this.pole.pole.split(" ")[0].trim();
      } else {
        return "";
      }
    },
    poleLabel() {
      if (this.pole) {
        let getLabel = this.getEquipmentName(this.pole.equipment);

        if (!getLabel) {
          return " ";
        } else if (getLabel.length > 1) {
          return "★";
        } else if (getLabel.length == 1) {
          return `${getLabel.join(",").toUpperCase()}`;
        }
      } else {
        return "";
      }
    },
    poleColor() {
      if (this.pole.status == "critical") {
        return "bg-critical";
      } else if (this.pole.status == "low") {
        return "bg-low";
      } else if (
        this.pole.status == "minor" ||
        this.pole.status == "cautious"
      ) {
        return "bg-minor";
      } else {
        return "bg-normal";
      }
    },
    maintenanceStatus() {
      if (
        this.pole &&
        this.pole.defectsMaintained &&
        this.pole.defectsMaintained.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    maintenanceColor() {
      if (
        this.pole &&
        this.pole.defectsMaintained &&
        this.pole.defectsMaintained.length > 0
      ) {
        let uploadedMaintenance = this.pole.defectsMaintained.filter(
          (d) => d.userUpload
        ).length;

        let approvedMaintenance = this.pole.defectsMaintained.filter(
          (d) => d.userApprove
        ).length;

        if (uploadedMaintenance < 1) {
          return "text-muted";
        } else if (
          approvedMaintenance >= this.pole.defectsMaintained.length
        ) {
          return "text-success";
        } else {
          return "text-warning";
        }
      } else {
        return "";
      }
    },
  },
  methods: {
    getEquipmentName(equipment) {
      let equipmentList = [];

      equipment.forEach((eq) => {
        equipmentList.push(eq.text.split("-")[0].trim());
      });

      if (equipmentList.length > 0) {
        return equipmentList;
      } else {
        return null;
      }
    },
    viewPole(pole) {
      this.$router.push({ name: "list", query: { poleId: pole.poleId } });
    },
    movePin(index, type) {
      let pin = this.$refs[`mappin${index}`];

      if (pin) {
        if (type) {
          pin.style.zIndex = this.total * 2 + index;
        } else {
          pin.style.zIndex = this.total + index;
        }
      }
    },
  },
  mounted() {
    new mapboxgl.Marker(this.$el)
      .setLngLat([this.pole.lng, this.pole.lat])
      .addTo(this.map);
  },
};
</script>
